import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { SubscriptionWInstance } from '../../subscription-management/subscription-management.component';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
@Component({
    selector: 'ms-subscription-table',
    templateUrl: './subscription-table.component.html',
    styleUrls: ['./subscription-table.component.scss'],
})
export class SubscriptionTableComponent implements OnInit, OnChanges {
    @Input() dataSourceSubscription: MatTableDataSource<SubscriptionWInstance>;
    @Input() ifNfs: boolean;
    @Input() disableButtonNFS: boolean;
    @Input() isExcellencePartnerMC: boolean;
    @Input() isPremiumPartnerMC: boolean;
    @Input() subscriptionFound: boolean;
    @Input() nfsMessageExcellence: string;
    @Input() nfsMessagePremium: string;
    @Input() searchSubscription: string;
    @Output() setSubscription = new EventEmitter<any>();
    @Output() applyFilter = new EventEmitter<string>();
    isComponentInitialized = false;
    displayedColumnSubscription: string[] = ['DescriSub'];
    public smallTable: boolean = false;

    _paginatorSubscriptions: MatPaginator;
    @ViewChild('paginatorSubscriptions') set paginatorSubscriptions(contentAccounts: MatPaginator) {
        if (contentAccounts) {
            // initially setter gets called with undefined
            this._paginatorSubscriptions = contentAccounts;
            const paginatorIntl = this._paginatorSubscriptions._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceSubscription) {
                this.dataSourceSubscription.paginator = this._paginatorSubscriptions;
            }
        }
    }

    constructor(
        public storeRoleService: StoreRolesService,
        public variable: TranslatedVariables,
        private breakpointObserver: BreakpointObserver
    ) {}

    ngOnInit(): void {
        this.isComponentInitialized = true;
        this.breakpointObserver.observe(['(width< 1100px)']).subscribe((result) => {
            this.smallTable = result.matches;
        });
    }

    ngOnChanges() {
        if (this.isComponentInitialized && this.dataSourceSubscription) {
            this.dataSourceSubscription.paginator = this._paginatorSubscriptions;
        }
    }

    clearSubscriptionSearch() {
        this.searchSubscription = '';
        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = this.searchSubscription.trim().toLowerCase();
        this.subscriptionFound = true;
    }

    onClickSetSubscription(event: string) {
        this.setSubscription.emit(event);
    }

    onClickApplyFilter(event: string) {
        this.applyFilter.emit(event);
    }
}
